/**
 * A/B Test - Simple & Solid
 *
 * - Assigns user to variant A or B once, stored in localStorage
 * - Adds class 'ab-a' or 'ab-b' on <body>
 * - Sets GA4 user property 'ab_variant' so tous les events GA sont filtrables par A/B
 *
 * Usage: document.body.dataset.abVariant  →  'A' ou 'B'
 */

(function () {
  var STORAGE_KEY = 'ab_variant';

  var isPinterest =
    document.referrer.includes('pinterest.') || new URLSearchParams(location.search).get('utm_source') === 'pinterest';

  var variant;

  if (isPinterest === true) {
    variant = Math.random() < 0.5 ? 'A' : 'B';
    localStorage.setItem(STORAGE_KEY, variant);
  } else {
    variant = 'A';
    localStorage.setItem(STORAGE_KEY, variant);
  }

  // Expose variant on <html> immediately (before DOMContentLoaded)
  document.documentElement.setAttribute('data-ab', variant);

  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('ab-' + variant.toLowerCase());
    document.body.dataset.abVariant = variant;

    // Set GA4 user property + event pour forcer l'envoi
    function sendAbVariantToGA(v) {
      if (typeof gtag !== 'function') return;
      gtag('set', 'user_properties', { ab_variant: v });
      gtag('event', 'ab_variant_assigned', { ab_variant: v });
    }

    // Tentative immédiate, puis retry si gtag pas encore prêt
    if (typeof gtag === 'function') {
      sendAbVariantToGA(variant);
    } else {
      window.addEventListener('load', function () {
        sendAbVariantToGA(variant);
      });
    }
  });
})();
